<template>
  <LayoutContainer :id="_id" class="mb-12 mt-8">
    <ClientOnly>
      <swiper-container
        v-if="gallery && gallery.length"
        class="mb-5"
        :navigation="true"
        style="--swiper-navigation-size: 30px; --swiper-theme-color: #000"
      >
        <swiper-slide
          v-for="(image, index) in gallery"
          :key="`gallery-${index}`"
        >
          <NuxtImg
            :src="image.asset?._ref"
            sizes="100vw sm:640px"
            width="640"
          />
        </swiper-slide>
      </swiper-container>
    </ClientOnly>

    <h1 class="mb-5 text-center text-2xl font-bold tracking-wide">
      {{ title }}
    </h1>

    <p class="mb-8 text-center text-xs" v-if="!hideTimestamp">
      <strong>Date</strong>&nbsp;
      <time :datetime="dayjs(publishedAt).utc().format()">{{
        dayjs.tz(publishedAt).format("ll")
      }}</time>
    </p>

    <PostContent :content="content" />
  </LayoutContainer>
</template>

<script setup lang="ts">
import type { QueryEditorial } from "~/@types/editorial"

const dayjs = useDayjs()

const props = defineProps<{
  post: QueryEditorial
}>()

const { post } = toRefs(props)

const { _id, title, content, gallery, publishedAt } = useEditorial(post.value)
const hideTimestamp = computed(() => post.value.section?.hideTimestamp ?? false)
</script>
